import { planningAPI } from "../../axios";

export const actions = {

    //KpiBaseLine
    GetKpiBaseLineByCampus(context, data){
        return planningAPI.get(`KpiBaseLine/Campus/${data.campusId}/IndicatorItem/${data.indicatorItemId}`);
    },
    GetSingleKpiBaseLine(context, data){
        return planningAPI.get(`KpiBaseLine/${data}`);
    },
    UpdateKpiBaseLine(context, data){
        return planningAPI.put(`KpiBaseLine/Update/${data.id}`, data);
    },
    DeleteKpiBaseLine(context, data){
        return planningAPI.delete(`KpiBaseLine/Remove/${data}`);
    },
    CreateKpiBaseLine(context, data){
        return planningAPI.post(`KpiBaseLine/Add`, data);
    },

}